angular.module('impactx.datedisplay').component('ixDateDisplay', {
        controller: 'DateDisplayCtrl',
        templateUrl: 'shared/datedisplay/templates/date-display.html'
    }
);